import createIcon from '../../createIcon';

/**
 * @component @name KeyboardOptionKey
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgNUgxNVY3SDIxVjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNOSA1SDNWN0g3Ljg1TDE0Ljc3IDE5SDIxVjE3SDE1LjkzTDkgNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const KeyboardOptionKey = createIcon('KeyboardOptionKey', [
  ['path', { d: 'M21 5H15V7H21V5Z', key: 'gr9isg' }],
  ['path', { d: 'M9 5H3V7H7.85L14.77 19H21V17H15.93L9 5Z', key: 'u1byzp' }],
]);

export default KeyboardOptionKey;
